<script lang="ts">
	import { Icons } from '$lib/components/icon'
	import { InfoMessageType } from '$lib/components/infoMessage/index'
	import { Icon } from '@repo/ui'

	interface Props {
		text?: string
		type?: InfoMessageType
		children?: import('svelte').Snippet
	}

	let { text = '', type = InfoMessageType.info, children }: Props = $props()
</script>

<div
	class="
  flex items-center gap-2 rounded-md border
  {type === InfoMessageType.error
		? 'border-red-400 bg-red-100 px-4 py-2 text-base text-red-600'
		: type === InfoMessageType.success
			? 'border-green-400 bg-green-100 px-7 py-4 text-sm text-green-600 dark:border-green-600 dark:bg-green-900/30 dark:text-green-200'
			: type === InfoMessageType.info
				? 'dark:bg-opacity-30 border-sky-400 bg-sky-100 px-7 py-4 text-sm text-sky-600 dark:border-sky-600 dark:bg-sky-900 dark:text-sky-200'
				: type === InfoMessageType.upgrade
					? 'border-primary-400 bg-primary-100 text-primary-600 dark:border-primary-500 dark:bg-primary-700 dark:text-primary-200 gap-2 px-4 py-4 text-sm md:px-7'
					: 'dark:bg-opacity-30 border-yellow-100 bg-yellow-50 px-7 py-4 text-sm text-yellow-900 dark:border-yellow-700 dark:bg-yellow-900 dark:text-yellow-50'}
"
>
	{#if type === InfoMessageType.info}
		<Icon src={Icons.InformationCircle} />
		<div class="ml-2"></div>
	{:else if type === InfoMessageType.warning}
		<Icon class="dark:text-yellow-500" src={Icons.ExclamationTriangle} />
		<div class="ml-2"></div>
	{:else if type === InfoMessageType.success}
		<Icon class="dark:text-green-500" src={Icons.CheckCircle} />
		<div class="ml-2"></div>
	{/if}
	{#if text}
		{text}
	{:else}
		{@render children?.()}
	{/if}
</div>
